import { render } from "./search.page.vue?vue&type=template&id=3756d4fa"
import script from "./search.page.vue?vue&type=script&lang=js"
export * from "./search.page.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programmazione\\Nodejs\\CallER\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__